export const BASIC_TOKEN = 'a2F6YW5leHByZXNzLWN1c3RvbWVyOmN1c3RvbWVyU2VjcmV0S2V5';
export const BASIC_BEARER = `Bearer ${BASIC_TOKEN}`; 